const initialState = {
  regions: null,
  segments: null,
  states: null,
  cities: null,
};

export default initialState;